import type { RoomSkillsData, RoomSkillsParams } from './skills-matrix.types';

import { apiSlice } from 'src/features/api/api-slice';
import { RTKQueryTag } from 'src/common/constants';
import { ApiResponse } from 'src/common/interfaces';

export const skillsMatrixApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRoomsBySkill: builder.query<ApiResponse<RoomSkillsData>, RoomSkillsParams>({
      query: ({ skill, role, segment }) => `rooms/skills/${skill.code}?role=${role}&segment=${segment}`,
      providesTags: [RTKQueryTag.SkillsMatrix],
    }),
  }),
});

export const { useGetRoomsBySkillQuery } = skillsMatrixApiSlice;
